import { useState } from 'react'
import { Link } from 'react-router-dom'
import { AppShell } from '../components/AppShell'

const FAQ: Array<{ q: string; a: string }> = [
  { q: 'How does a challenge work?',
    a: 'You start with a virtual challenge balance (e.g. €25,000 on the Pro tier) and need to reach a profit target across Phase 1 and Phase 2 while staying within drawdown and daily-loss limits. After Phase 3 review, successful traders unlock a funded account.' },
  { q: 'What is the drawdown floor?',
    a: 'A static floor calculated as starting balance × (1 − max DD %). If your balance falls below the floor at any point, the challenge ends. The floor does not move with peak — once you make profit, the floor stays put.' },
  { q: 'When are bets settled?',
    a: 'Settlement runs automatically when the sportsbook returns a final result, usually within 30 seconds of the final whistle. CLV (closing line value) is captured at T-30s before the event.' },
  { q: 'How do payouts work in the funded program?',
    a: 'Funded cycles run for a fixed duration. At the end of each cycle, your profit share (per tier terms) is queued as a payout request. KYC is required before the first payout is paid.' },
  { q: 'Can I have more than one active challenge?',
    a: 'Currently a trader has one active challenge account at a time. Once one is funded or closed, you may start another.' },
]

export function HelpPage() {
  const [open, setOpen] = useState<number | null>(0)
  const [search, setSearch] = useState('')

  const filtered = FAQ.filter((f) =>
    f.q.toLowerCase().includes(search.toLowerCase()) || f.a.toLowerCase().includes(search.toLowerCase()),
  )

  return (
    <AppShell page="help" breadcrumb={<span className="topbar__breadcrumb-current">Help</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Support</span></p>
          <h1 className="page-header__title">Help &amp; support</h1>
          <p className="page-header__subtitle">Find answers fast or reach out to the team.</p>
        </div>
      </header>

      <div className="settings-content">
        <section className="settings-card">
          <header className="settings-card__header">
            <div className="settings-card__title-group">
              <h2 className="settings-card__title">Search articles</h2>
              <p className="settings-card__description">Quickly find what you need.</p>
            </div>
          </header>
          <div className="settings-card__body">
            <div className="field">
              <input className="field__input" type="search" placeholder="Try “drawdown” or “payout”…"
                value={search} onChange={(e) => setSearch(e.target.value)} />
            </div>
          </div>
        </section>

        <section className="settings-card">
          <header className="settings-card__header">
            <h2 className="settings-card__title">Frequently asked</h2>
            <p className="settings-card__description">The most common questions traders ask us.</p>
          </header>
          <div className="settings-card__body">
            <div className="faq-list">
              {filtered.length === 0 && (
                <p style={{ color: 'var(--text-tertiary)', fontSize: 'var(--text-sm)', padding: 'var(--space-4)' }}>
                  No matches. Try a different keyword or contact support below.
                </p>
              )}
              {filtered.map((f, i) => (
                <details key={f.q} className="faq-item" open={open === i}
                  onToggle={(e) => setOpen((e.currentTarget as HTMLDetailsElement).open ? i : null)}>
                  <summary className="faq-item__summary">
                    <span>{f.q}</span>
                    <svg className="faq-item__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </summary>
                  <div className="faq-item__body"><p>{f.a}</p></div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="settings-card">
          <header className="settings-card__header">
            <h2 className="settings-card__title">Still need help?</h2>
            <p className="settings-card__description">
              Email us at <a href="mailto:support@rivalprop.com" style={{ color: 'var(--color-primary)' }}>support@rivalprop.com</a> and
              we'll respond within one business day. Check{' '}
              <Link to="/system-status" style={{ color: 'var(--color-primary)' }}>system status</Link> first for ongoing incidents.
            </p>
          </header>
        </section>
      </div>
    </AppShell>
  )
}
